export default __webpack_public_path__ + "static/media/transmission.089ef830.jpeg";